import React, { useState, useEffect } from "react";

// Loadash
import debounce from "lodash/debounce";

// Helper
import { getCountryCode } from "../../../utils/oneintelligence/OneIntelligenceHelper";

// Services
import OneIntelligenceServices from "../../../services/OneIntelligence.services";
import TrackFeatureServices from "../../../services/TrackFeature.services";

// Helper
import { isHasScrapeTopicBrandPermission } from "../../../utils/MainHelper";

// Components
import { Button, Input, Space } from "antd";
import { ArrowLeftOutlined, LoadingOutlined, CloseOutlined, CheckOutlined } from "@ant-design/icons";

const TargetInputChecker = ({
    title = "",
    description = "",
    loading = false,
    onCancel = () => { },
    onSave = () => { },
    onChange = () => { },
    onClickRedirect = () => { },
}) => {
    const [targetValue, setTargetValue] = useState("");
    const [checking, setChecking] = useState(false);
    const [message, setMessages] = useState("");

    const handleChange = debounce(async (e) => {
        const inputValue = e.target.value.trim();
        setTargetValue(inputValue);
        onChange(inputValue);
    }, 1000);

    const handleClose = () => {
        onCancel(targetValue);
    };

    const handleSubmit = () => {
        onSave(targetValue);
    };

    const handleRedirect = () => {
        onClickRedirect(targetValue);
    };

    const renderSuffix = () => {
        const style = {
            fontSize: "11px"
        }
        if (targetValue && checking) return <LoadingOutlined style={{ ...style }} />;
        else if (targetValue && message) return <CloseOutlined style={{ ...style, ...{ color: "#ff4d4f" } }} />
        else if (targetValue && !message) return <CheckOutlined style={{ ...style, ...{ color: "#52c41a" } }} />
        else return null;
    };

    const renderMessage = () => {
        let resultMessage = message;
        if (
            isHasScrapeTopicBrandPermission() &&
            resultMessage.includes("Savant:")
        ) {
            resultMessage = (
                <>
                    {resultMessage?.replace("Savant:", "") + " or "}
                    <Button
                        type="link"
                        onClick={handleRedirect}
                        style={{
                            padding: "0",
                            fontSize: "13px",
                        }}
                    >
                        Add New to My Own Knowledge Base
                    </Button>
                </>
            );
        } else resultMessage = resultMessage?.replace("Savant:", "");
        return resultMessage;
    };

    useEffect(() => {
        let listsubjects = null;
        if (targetValue) {
            setChecking(true);
            const region = getCountryCode("savant");
            if (!region) return;
            let usedUrl = "";
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({
                featureKey: "advanceSavantRead",
            });

            const callBackURL = (params, url) => {
                usedUrl = url;
                startMonitor(params, { url: usedUrl });
            };

            const callBackCancel = () => {
                endMonitor({ message: "Cancel API Call." }, { url: usedUrl });
            };

            const callBackStatus = (status) => {
                setMessages(status);
            };

            const api = async (recall) => {
                listsubjects = await OneIntelligenceServices.listSubjects(
                    100,
                    [targetValue.toLowerCase()],
                    region,
                    0,
                    callBackStatus,
                    callBackCancel,
                    callBackURL
                );
                setMessages("Crawling SQREEM knowledge base...");
                listsubjects.thenpromise.then((resp) => {
                    setChecking(false);
                    if (!recall) endMonitor(resp, usedUrl);
                    if (!resp) return;
                    if (resp.notLoaded) {
                        setMessages("Country is not loaded.");
                    } else if (resp.stillLoading) {
                        setMessages("Country is still loading please wait.");
                    } else if (resp.noresult) {
                        setMessages("No Result.");
                    } else {
                        const respKeywords = resp.data || resp.response?.data;
                        const resultkeywords =
                            OneIntelligenceServices.filterSavantKeywords(respKeywords);
                        if (resultkeywords.isError) {
                            setMessages(resultkeywords.error);
                        } else {
                            setMessages("");
                        }
                    }
                });
            };

            api();
        } else {
            setChecking(false);
        }

        return () => {
            if (listsubjects) listsubjects.cancel(true);
        };
    }, [targetValue]);

    return (
        <div className="targetinput-checker">
            <div className="targetinput-checker-header">
                <Button
                    type="link"
                    icon={<ArrowLeftOutlined />}
                    onClick={handleClose}
                    style={{ paddingLeft: "0px", marginBottom: "16px" }}
                >
                    Back
                </Button>
            </div>
            <div className="targetinput-checker-form">
                <label>{title}</label>
                <Input
                    onChange={handleChange}
                    suffix={renderSuffix()}
                    readOnly={checking || loading}
                />
                <p
                    style={{
                        color:
                            message.includes("Crawling") || message.includes("/")
                                ? "#52c41a"
                                : "#ff4d4f",
                        fontWeight: "500",
                    }}
                >
                    {renderMessage()}
                </p>
                {
                    !message ? <p>{description}</p> : null
                }
            </div>
            <div className="targetinput-checker-action">
                <Space>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="primary" onClick={handleSubmit} disabled={checking || message} loading={loading}>
                        Save
                    </Button>
                </Space>
            </div>
        </div>
    );
};

export default TargetInputChecker;
